import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DebounceService {
  private timers: Map<string, ReturnType<typeof setTimeout>> = new Map();

  /**
   * Debounces a callback by the given delay (default 500ms).
   * Use a unique `key` per input to allow multiple independent debounces.
   */
  debounce(key: string, callback: () => void, delay: number = 500): void {
    const existing = this.timers.get(key);
    if (existing) clearTimeout(existing);
    const timer = setTimeout(() => {
      callback();
      this.timers.delete(key);
    }, delay);
    this.timers.set(key, timer);
  }
}
